module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, _vm._l((_vm.sides), function(side) {
    return _c('side-modal', {
      key: side.identidade,
      attrs: {
        "tit": side.titulo,
        "subtit": side.subtitulo,
        "subtDetl": side.subtDetalhe,
        "larg": side.largura,
        "id": side.identidade,
        "abreMaisUm": side.abreProximo,
        "aberto": side.aberto
      },
      on: {
        "fechou": function($event) {
          return _vm.fechaFromChild(side)
        },
        "abreFromChild": function($event) {
          _vm.abreSide(_vm.sides[_vm.sides.indexOf(side) + 1])
        },
        "largura": _vm.minima
      }
    }, [_vm._t(side.identidade)], 2)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22e31d50","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/side-modal/index.vue
// module id = TQeL
// module chunks = 5